import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

function getOrCreateVisitorId() {
  let id = localStorage.getItem("ogxbox_visitor_id");
  if (!id) {
    // Simple UUID v4-ish without external deps
    id = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) => {
      const r = (crypto.getRandomValues(new Uint8Array(1))[0] & 15) >> (c / 4);
      return (c ^ r).toString(16);
    });
    localStorage.setItem("ogxbox_visitor_id", id);
  }
  return id;
}

/**
 * Fires a /api/visitors/ping whenever the route changes.
 * Backend dedupes within 60s, so SPA re-renders won't flood the DB.
 */
export default function VisitorTracker() {
  const { pathname } = useLocation();
  const lastPath = useRef(null);

  useEffect(() => {
    if (lastPath.current === pathname) return;
    lastPath.current = pathname;

    // Skip tracking for admin paths — admins viewing the store don't count as visitors
    if (pathname.startsWith("/admin")) return;

    const visitor_id = getOrCreateVisitorId();
    axios.post(`${API}/api/visitors/ping`, {
      visitor_id,
      path: pathname,
      referrer: document.referrer || "",
    }).catch((err) => {
      // Silent — tracking failure shouldn't disturb the user
      console.debug("Visitor ping failed:", err.message);
    });
  }, [pathname]);

  return null;
}
